var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcContests(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M657 734v159c0 19-20 30-35 20l-122-84-122 84c-15 10-35-1-35-20V734c47 26 100 40 157 40s110-14 157-40zM500 125c161 0 292 135 292 301 0 167-131 302-292 302S208 593 208 426c0-166 131-301 292-301zm16 126c-6-14-25-14-31 0l-44 96-98 16c-14 2-20 21-10 32l71 75-16 105c-3 16 12 27 25 20l87-50 88 50c13 7 28-4 25-20l-16-105 70-75c11-11 5-30-9-32l-98-16z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContests);
export default __webpack_public_path__ + "static/media/ic_contests.193d5b2a99e05d6e9f198f0f3588e33e.svg";
export { ForwardRef as ReactComponent };